import React, { useState } from "react"
import { Select, Space, Input, DatePicker } from "antd"

const WeightDisputeFilters = ({filters, onFiltersChange}) => {
  const [searchField, setSearchField] = useState("trackingNo")
  const searchBy = (
    <Select defaultValue="trackingNo" className="select-before" onChange={value => setSearchField(value)}>
      <Select.Option value="trackingNo">Tracking No</Select.Option>
      <Select.Option value="userEmail">User Email</Select.Option>
    </Select>
  );

  return (
    <Space size="large" wrap>
      <div>
        <DatePicker.RangePicker
          value={[filters.startDate, filters.endDate]}
          onChange={dates => (dates 
              ? onFiltersChange({...filters, startDate: dates[0], endDate: dates[1]}) 
              : onFiltersChange({...filters, startDate: undefined, endDate: undefined})
          )}
        />
      </div>

      <div>
        <Input.Search 
          addonBefore={searchBy}
          placeholder="Search" 
          onSearch={term => onFiltersChange({...filters, search: term, searchField }) } 
        />
      </div>

      <div>
        <Input.Search 
          addonBefore="Weight Diff More Than"
          placeholder="KG" 
          onSearch={term => onFiltersChange({...filters, weightDiffFrom: Number(term) }) } 
        />
      </div>

      <div>
        <Input.Search 
          addonBefore="Price Diff More Than"
          placeholder="RM" 
          onSearch={term => onFiltersChange({...filters, priceDiffFrom: Number(term) }) } 
        />
      </div>
    </Space>
  )
}

export default WeightDisputeFilters;
